import React, { useState } from 'react'
import { useAppSelector } from '../../../../../../app/hooks'
import { InitState } from '../../../../../../redux/reducers/root/initialState'
import { selectHasRequiredAddressForValuation } from '../../../../../../redux/selectors/insertionSelectors'
import { useIsRecommendedPriceEnabled } from '../../../UseIsRecommendedPriceEnabled'
import { RentPriceCheck } from './rent-price-check/RentPriceCheck'
import { RentPriceCheckSkeleton } from './rent-price-check/rent-price-check-skeleton/RentPriceCheckSkeleton'
import { MissingRequiredDataNotification } from './missing-required-data-notification/MissingRequiredDataNotification'
import { useLoadRentValuationData } from './useLoadRentValuationData'

export function RecommendedPriceNotification() {
  const [isRentPriceCheckExpanded, setIsRentPriceCheckExpanded] = useState(false)
  const isRecommendedPriceEnabled = useIsRecommendedPriceEnabled()
  const { minValue, maxValue, recommendedValue, isPending } = useAppSelector(
    (state: InitState) => state.valuationFeature
  )
  const insertionData = useAppSelector((state: InitState) => state.insertionFeature.insertionData)
  const hasRequiredAddressData = useAppSelector(selectHasRequiredAddressForValuation)

  useLoadRentValuationData(insertionData, isRecommendedPriceEnabled)

  if (!isRecommendedPriceEnabled) {
    return null
  }

  if (isPending) {
    return (
      <div className='grid-item one-whole'>
        <RentPriceCheckSkeleton />
      </div>
    )
  }

  if (!hasRequiredAddressData) {
    return (
      <div className='grid-item one-whole'>
        <MissingRequiredDataNotification />
      </div>
    )
  }

  if (minValue === undefined || maxValue === undefined || recommendedValue === undefined) {
    return null
  }

  return (
    <div className='grid-item one-whole'>
      <RentPriceCheck
        minValue={minValue}
        maxValue={maxValue}
        recommendedValue={recommendedValue}
        price={insertionData.price}
        livingSpace={insertionData.livingSpace}
        isExpanded={isRentPriceCheckExpanded}
        onExpandedChange={setIsRentPriceCheckExpanded}
      />
    </div>
  )
}
